import { useState } from 'react';
import { useQuery } from '@/hooks';
import { useGetUsersListQuery } from './hooks';
import { UsersListView } from './UsersListView';
import { UsersListResults } from './components';
import { UsersListSearchBar } from './components';

const UsersListContainer = () => {
    const query = useQuery();
    const [search, setSearch] = useState({});
    const { data, loading } = useGetUsersListQuery({ ...search });

    const page = parseInt(query.get('page'));
    const pageSize = parseInt(query.get('pageSize'));
    const users = data ? JSON.parse(JSON.stringify(data.getUsersList)) : [];

    return (
        <UsersListView>
            {{
                results: <UsersListResults data={users} initialPage={page} initialPageSize={pageSize} loading={loading} />,
                searchBar: <UsersListSearchBar numberOfMatches={users.length} onSearch={setSearch} />,
            }}
        </UsersListView>
    );
};

export { UsersListContainer };
